export const METER_TELEMETRY_STATES = {
  _4: "Pending",
  _3: "Override Off",
  _2: "Daily Cap",
  _1: "Credit Expired",
  A_0: "Override Disabled",
  A_1: "On",
  A_2: "Override On",
};

export const METER_TELEMETRY_STATE_VALUES = {
  _4: -4,
  _3: -3,
  _2: -2,
  _1: -1,
  A_0: 0,
  A_1: 1,
  A_2: 2,
};
